import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitSimActiveModel } from '@apps-common/types/management/unit'

export const createUnitActive = async (model: IUnitSimActiveModel, nonAllocatedSimId: number): Promise<IUnitSimActiveModel> =>
  axios.post(`/management/unit/addunitactive?nonAllocatedSimId=${nonAllocatedSimId}`, model).then((res) => res?.data?.data)

type Props = {
  model: IUnitSimActiveModel
  nonAllocatedSimId: number
}

export const useManagementCreateUnitActive = (notify?: boolean, onSuccess?: (data: IUnitSimActiveModel) => void) =>
  useMutation({
    mutationKey: ['createUnitActive'],
    mutationFn: ({ model, nonAllocatedSimId }: Props) => createUnitActive(model, nonAllocatedSimId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Created active device.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to create active device, please try again.')
      }
    },
    throwOnError: false
  })
